import { Directive } from '@angular/core';
@Directive({
    selector: '[disableLink]',
    host: {
        '(click)': 'preventDefault($event)'
    }
})
export class DisableLinkDirective {
    preventDefault(event) {
        event.preventDefault();
    } 
}


// WEBPACK FOOTER //
// ./src/directives/disable-link.ts